<template>
  <b-card no-body>
    <b-card-body id="invoice-card-body">
      <invoice-filter :filter-submitting="isLoading" @filter="loadItems" />
      <vue-good-table
        mode="remote"
        :sort-options="{ enabled: false }"
        :total-rows="totalRecords"
        :is-loading.sync="isLoading"
        :show-footer="true"
        :pagination-options="{
          enabled: true,
          jumpFirstOrLast: true,
          rowsPerPageLabel: t('Rows per page'),
          ofLabel: t('ofLabel'),
          nextLabel: t('nextLabel'),
          prevLabel: t('prevLabel'),
          dropdownAllowAll: false
        }"
        :rows="rows"
        :columns="getColumns"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'actions'">
            <span class="d-flex justify-content-center table-icon-buttons">
              <b-button
                :id="`edit-button-${props.row.id}`"
                variant="primary"
                type="button"
                size="sm"
                @click="detailInvoice(props.row)"
              >
                <feather-icon icon="ListIcon" size="15" />
                <b-tooltip
                  triggers="hover"
                  :target="`detail-button-${props.row.id}`"
                  :title="t('Detail Invoice')"
                  :delay="{ show: 0, hide: 0 }"
                  boundary="viewport"
                />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </b-card-body>
    <b-modal
      id="invoice-infos-modal"
      ref="invoice-infos-modal"
      size="md"
      ok-only
      :ok-title="t('Close')"
    >
      <b-col v-for="(item, index) in singleInvoice" :key="index">
        <b-row v-if="index !== 'vgt_id' && index !== 'originalIndex'">
          {{ handleKeyLanguage(index) }} : {{ item }}
        </b-row>
      </b-col>
    </b-modal>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTooltip, BButton, BModal, BRow, BCol } from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import InvoiceFilter from '@/views/pages/invoice-module/InvoiceFilter.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    BCard,
    BCardBody,
    BTooltip,
    BButton,
    BModal,
    BRow,
    BCol,

    VueGoodTable,

    InvoiceFilter
  },

  mixins: [helper],

  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      rows: [],
      singleInvoice: [],
      text: '',
      filterValues: {
        customerId: '',
        from: '',
        to: ''
      }
    };
  },
  computed: {
    direction() {
      if (this.$store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    getColumns() {
      if (!this.rows.length) {
        return [];
      }

      return [
        {
          label: this.$t('Order ID'),
          field: 'orderNo'
        },
        {
          label: this.$t('Customer'),
          field: 'customer.name'
        },
        {
          label: this.$t('Fee Total'),
          field: 'feeTotal'
        },
        {
          label: this.$t('Payment Type'),
          field: 'paymentType'
        },
        {
          label: this.$t('Weight'),
          field: 'weight'
        },
        {
          label: this.$t('Desi'),
          field: 'desi'
        },
        {
          label: this.$t('createdAt'),
          field: this.dateFormat
        },
        {
          label: this.$t('Actions'),
          field: 'actions'
        }
      ];
    }
  },
  async created() {
    this.loadItems();
  },
  methods: {
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps };
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange(params) {
      this.filter.page = 1;
      this.updateParams({ limit: params.currentPerPage });
      this.loadItems();
    },
    loadItems(filter) {
      const requestData = {};

      if (filter && filter.customer) {
        requestData.customer = filter.customer;
      }
      if (filter && filter.from && filter.to) {
        requestData.createdAt = [];
        requestData.createdAt.push(filter.from);
        requestData.createdAt.push(filter.to);
      }

      this.isLoading = true;

      if (
        requestData.dateFrom &&
        requestData.dateTo &&
        new Date(requestData.dateFrom) > new Date(requestData.dateTo)
      ) {
        this.showErrorMessage(this.$t('Big Date Error'), this.$t('Unsuccessful'));
        return;
      }

      useService
        .getInvoicesList(requestData)
        .then(response => {
          this.rows = response.data;
          this.totalRecords = response.meta.total;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // pagination geldiğinde burası aktif edilecek
    setFilter(data) {
      if (data) {
        this.filterValues = data;
        this.filter.page = 1;
        this.loadItems();
      } else {
        this.filterValues = {
          customerId: '',
          from: '',
          to: ''
        };
        this.filter.page = 1;
        this.loadItems();
      }
    },
    detailInvoice(data) {
      this.$refs['invoice-infos-modal'].show();
      this.singleInvoice = data;
    },
    handleKeyLanguage(item) {
      const { t } = useI18nUtils();
      return t(`${item}`);
    },
    dateFormat(item) {
      const dateObject = new Date(item.createdAt);
      return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
